api = require('../api.coffee').api()

class global.VariableResource extends ResourceBase
  @MODEL = Variable
  @SINGULAR_RESOURCE_NAME = 'variable'
  @PLURAL_RESOURCE_NAME = 'variables'

  index: (success, failure, params={}) ->
    api.get '/variables', params, { success: @collectionSuccess(success), failure }



// WEBPACK FOOTER //
// ./src/resources/variables.coffee